import CommentsSection from "./components/CommentsSection";

function App() {
  return <CommentsSection />;
}

export default App;
